
//import CTL_TopMenubar from "@/compo/CTL_TopMenubar";
import CTL_TopMenubar from "@/compo/CTL_TopMenubar";
import { useEffect, useRef } from "react";
import { Outlet, useLocation, } from "react-router";

const subMenuList =[
  {label:'처음으로', to:'/'},
  {label:'홈', to:'/admin'},
  //{label:'운영자 관리', to:'/admin/manager'},
  {label:'공지사항 관리', to:'/admin/notice'},
  {label:'대회 관리', to:'/admin/game-list'},
  
]
export default function AdminLayout(){
  
  const scrPanel = useRef<HTMLDivElement>(null);
  const location = useLocation();
  
  useEffect(()=>{
    //console.log('scrPanel',scrPanel.current!.scrollTop )
    scrPanel.current!.scrollTo({top:0})
  },[location])
  
  return <>
  <div className="
    overflow-hidden
    w-screen h-screen 
    flex flex-col
    items-center
    bg-zinc-100 
    ">
    
    <div className="
      flex-1 bg-white 
      xs:w-[440px] w-full 
      max-h-full
      flex flex-col
    ">
      <CTL_TopMenubar menuList={subMenuList}/>
      <div ref={scrPanel} className=" 
        flex-1  overflow-y-auto
      ">
          <div className="pt-3 min-h-[calc(100%-200px)] relative">
            <Outlet />
          </div>
          
      </div>
    </div>
  </div>
  </>
}